/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum ActionPlanNewAliases {
  ACTIONS_LIST_FIELD = 'actions-list-field',
  AUTOCOMPLETE_PROVIDER = 'autocomplete-provider',
  AVATAR_0 = 'avatar-0',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  DATE_FIELD_0 = 'date-field-0',
  FETCH_LOCATOR = 'fetch-locator',
  FIELD_1 = 'field-1',
  FIELD_2 = 'field-2',
  FIELD_3 = 'field-3',
  FIELD_5 = 'field-5',
  FIELD_ACTION = 'field-action',
  FIELD_DEADLINE = 'field-deadline',
  FIELD_DETAILS = 'field-details',
  FIELD_LOCATOR = 'field-locator',
  FIELD_RESPONSIBLE = 'field-responsible',
  FORM_ACTION = 'form-action',
  FORM_PLAN_DATA = 'form-plan-data',
  INPUT_0 = 'input-0',
  INPUT_1 = 'input-1',
  INPUT_2 = 'input-2',
  LINK_ADD = 'link-add',
  LOADER = 'loader',
  MAPPER_0 = 'mapper-0',
  MAPPER_AUTOCOMPLETE = 'mapper-autocomplete',
  PANEL_0 = 'panel-0',
  PANEL_ACTION_LIST = 'panel-action-list',
  PANEL_LINK = 'panel-link',
  PANEL_LOADER = 'panel-loader',
  PANEL_SAVE = 'panel-save',
  TEXT_0 = 'text-0',
  TEXT_AREA_0 = 'text-area-0',
  TEXT_AREA_1 = 'text-area-1',
  TEXT_AUTOCOMPLETE = 'text-autocomplete',
  WIZARD_ACTION_PLAN = 'wizard-action-plan',
  WIZARD_STEP_ACTIONS = 'wizard-step-actions',
  WIZARD_STEP_PLAN_DATA = 'wizard-step-plan-data',
}
export { ActionPlanNewAliases };
